// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vHtw","colBig":"styles_colBig__2f7a8","colSmall":"styles_colSmall__36YDV","shopifyNameWrapper":"styles_shopifyNameWrapper__IbO_a"};